import { useState } from 'react';
import { useDidMount, useWillUnmount } from 'rooks';

import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import Error from '@/components/common/Error';
import Loader from '@/components/common/Loader';

import { useDocumentPreview } from '@/data/document';

const ViewDialog = ({ document, open, setIsOpen }) => {
  const previewDocument = useDocumentPreview();
  const [apiError, setApiError] = useState('');
  const [isDownloading, setIsDownloading] = useState(true);
  const [url, setUrl] = useState(null);

  useDidMount(async () => {
    try {
      const url = await previewDocument(document);
      setUrl(url);
    } catch (error) {
      setApiError(error.message);
    } finally {
      setIsDownloading(false);
    }
  });

  useWillUnmount(() => {
    if (url) {
      window.URL.revokeObjectURL(url);
    }
  });

  const handleLoad = () => {
    setIsDownloading(false);
  };

  return (
    <Dialog open={open} onOpenChange={setIsOpen}>
      <DialogTrigger asChild></DialogTrigger>
      <DialogContent className="max-w-[95vw] px-2">
        <DialogHeader>
          <DialogTitle className="truncate max-w-[200px]">
            {document.name}
          </DialogTitle>
        </DialogHeader>
        {isDownloading && (
          <div className="h-screen max-h-[70vh] flex items-center justify-center">
            <Loader />
          </div>
        )}
        {url && (
          <iframe
            src={url}
            className="w-full h-screen max-h-[70vh]"
            onLoad={handleLoad}
          />
        )}
        {apiError && <Error error={apiError} />}
      </DialogContent>
    </Dialog>
  );
};

export default ViewDialog;
